import { Link } from "react-router-dom";

export default function ArticleCard({ article, onOpen }) {
  const imageBaseUrl = "http://localhost:5452/uploads/artigos/"; // ajuste se necessário
  const imageUrl = article.image
    ? `${imageBaseUrl}${article.image}`
    : "https://via.placeholder.com/400x300?text=Sem+Imagem";

    const description = (text, maxLength) => {
      if(text.length <= maxLength) return text;
      return text.substring(0, maxLength) + "...";
    }

  return (
    <div className="rounded-xl shadow-md overflow-hidden bg-white hover:shadow-lg transition flex flex-col">
      <img
        src={imageUrl}
        alt={article.title}
        className="w-full h-48 object-cover"
      />
      <div className="p-4 flex flex-col flex-grow">
        <Link
          to={`/posts/${article.id}`}
          className="text-xl font-wetgh text-gray-950 hover:underline no-underline"
        >
          {article.title}
        </Link>
        <p className="text-gray-600 text-sm mt-4">
          {description(article.content || "", 80)}
        </p>
        <div className="text-gray-600 text-sm">
          <p className="mb-0">{new Date(article.created_at).toLocaleDateString("pt-BR")}</p>
          <p>postador por: {article.usuario.nome} {article.usuario.sobrenome}</p>
        </div>
        <div className="mt-auto">
          <button
            onClick={() => onOpen(article)}
            className="mt-4 text-sm text-white bg-blue-500 px-3 py-1 rounded hover:bg-blue-600"
          >
            Ler Mais
          </button>
        </div>
      </div>
    </div>
  );
}
